module.exports = __webpack_public_path__ + "media/images/v2/header-2-9e153bd6f7e1a6cd6584384d2d26ad4e.png";